import {Outlet, useLocation} from 'react-router-dom';
import cn from 'clsx';
import {AUTH_INIT_MODELS, SHORT_LINK_TYPE} from '@chekin/core';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {PATHS} from 'routes/constants';
import {useChekinSDK} from '../../context/ChekinSDK';
import {useLayoutMode} from 'hooks/useLayoutMode';
import PageSideBar from '../PageSideBar';
import SideBarUniversalLink from 'components/PageSideBarUniversalLink/Components';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';
import {useKioskoStore} from 'context/kiosko';
import {KioskoWrapper} from 'components/common/KioskoWrapper';
import ChekinProSettings from 'ChekinProSettings';

const LinksWithoutSidebar: string[] = [SHORT_LINK_TYPE.lock];

type Props = {
  isLoading?: boolean;
};
function RootLayout({isLoading}: Props) {
  const {linkType, isAuthInitialization, modelName} = useChekinSDK();
  const layoutMode = useLayoutMode();

  const {isMatch: isMobile} = useScreenResize(DEVICE.laptop);
  const [, , , token] = window.location.href.split('/');
  const isWrongPage = !token && !ChekinProSettings.apiKey;
  const isLinkWithoutSidebar = LinksWithoutSidebar.includes(linkType ?? '');
  const isUniversalLink =
    modelName === AUTH_INIT_MODELS.housing || modelName === AUTH_INIT_MODELS.user;
  const isHousingGuidebooksLink = linkType === SHORT_LINK_TYPE.housingGuidebook;

  const location = useLocation();
  const isAuthPage = location.pathname.includes(PATHS.auth.root);
  const isRateYourStayPage = location.pathname.includes(PATHS.checkout.rateYourStay);
  const isThanksPage = location.pathname.includes(PATHS.checkout.thanks);

  const isKiosko = useKioskoStore(state => state.connection.isConnected);
  const isSideBarVisible =
    !isAuthInitialization &&
    !isMobile &&
    !isWrongPage &&
    !isLinkWithoutSidebar &&
    !isUniversalLink &&
    !isAuthPage &&
    !isRateYourStayPage &&
    !isThanksPage &&
    layoutMode === 'default';

  const invalidLink = !isSideBarVisible && !isUniversalLink;

  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    <KioskoWrapper isKiosko={isKiosko}>
      <div
        className={cn(
          'page-wrapper',
          'block',
          'lg:grid',

          invalidLink && 'lg:grid-cols-[none]',
          !invalidLink && isUniversalLink && 'lg:grid-cols-[352px_auto]',
          !invalidLink && !isUniversalLink && 'lg:grid-cols-[284px_auto]',
          invalidLink && '[1126px]:grid-cols-[none]',
          !invalidLink && isUniversalLink && '[1126px]:grid-cols-[552px_auto]',
          !invalidLink && !isUniversalLink && '[1126px]:grid-cols-[284px_auto]',
          invalidLink && '[1126px]:h-screen',
          isHousingGuidebooksLink && 'lg:grid-cols-[none]',
          'kiosko:md:block',
          'kiosko:[1126px]:block',
          '[&_[data-slot=scroll-area-viewport]]:h-[100dvh]',
        )}
      >
        {isSideBarVisible && <PageSideBar />}
        {!isHousingGuidebooksLink && isUniversalLink && layoutMode === 'default' && (
          <SideBarUniversalLink />
        )}
        <Outlet />
      </div>
    </KioskoWrapper>
  );
}

export {RootLayout};
